import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './colorActionTypes';
import * as actions from './colorActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getColorSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getColors, payload);
    yield put(actions.getColorDataAction(data));
  } catch (e) {
    yield put(actions.getColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createColorSaga(action) {
  try {
    console.log('createColorSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create color API payload:', payload);
    
    const { data } = yield call(endpoints.createColor, payload);
    console.log('Create color API response:', data);
    
    yield put(actions.createColorDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/color');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createColorSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateColorSaga(action) {
  try {
    console.log('updateColorSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update color API payload:', payload);
    
    const { data } = yield call(endpoints.updateColor, payload);
    console.log('Update color API response:', data);
    
    yield put(actions.updateColorDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getColorRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/color');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateColorSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteColorSaga(action) {
  try {
    console.log('deleteColorSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete color API payload:', payload);
    
    const { data } = yield call(endpoints.deleteColor, payload);
    console.log('Delete color API response:', data);
    
    yield put(actions.deleteColorDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getColorRequestAction());
    }
    
  } catch (e) {
    console.error('deleteColorSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* colorSaga() {
  yield all([
    takeEvery(types.GET_COLOR_REQUEST, getColorSaga),
    takeEvery(types.CREATE_COLOR_REQUEST, createColorSaga),
    takeEvery(types.UPDATE_COLOR_REQUEST, updateColorSaga),
    takeEvery(types.DELETE_COLOR_REQUEST, deleteColorSaga),
  ]);
}
